// 在http.js中引入axios
import axios from 'axios' // 引入axios
import QS from 'qs' // 引入qs模块，用来序列化post类型的数据，后面会提到

// 环境的切换
if (process.env.NODE_ENV === 'development') {
//   axios.defaults.baseURL = 'http://129.211.168.158:8080/itouch/'
//   axios.defaults.baseURL = 'http://192.168.0.156:8080/itouch/'
    axios.defaults.baseURL = 'https://admin.cases.immersivetouch.com/'
//     axios.defaults.baseURL = 'http://dev.cases.immersivetouch.com/itouch/'
//   axios.defaults.baseURL = 'http://127.0.0.1:9090/itouch/'
//   axios.defaults.baseURL = 'http://127.0.0.1:8080/itouch/'
} else if (process.env.NODE_ENV === 'debug') {
    axios.defaults.baseURL = 'https://admin.cases.immersivetouch.com/'
} else if (process.env.NODE_ENV === 'production') {
//   axios.defaults.baseURL = 'http://129.211.168.158:8080/itouch/'
    axios.defaults.baseURL = 'https://admin.cases.immersivetouch.com/'
//     axios.defaults.baseURL = 'http://dev.cases.immersivetouch.com/itouch/'
//     axios.defaults.baseURL = 'http://127.0.0.1:9090/itouch/'
//   axionpm s.defaults.baseURL = 'http://127.0.0.1:8080/itouch/'
//   axios.defaults.baseURL = 'http://127.0.0.1:8080/'
}

axios.defaults.timeout = 100000

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

/** np
 * get方法，对应get请求 //只需要引入一次
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) { // aaaa这个只是一个get请求的方法名
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

export function post(url, params) { // bbbb这个只是一个post请求的方法名
    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params)).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

export function file(url, params) { // bbbb这个只是一个post请求的方法名
    return new Promise((resolve, reject) => {
        axios.post(url, params, {
            'Content-Type': 'multipart/form-data'
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

export function dow(url, params) { // bbbb这个只是一个post请求的方法名
    let str = '';
    for (let key in params) {
        if (params[key] != '' && params[key] != 'null' && params[key] != undefined) {
            str += key + '=' + params[key] + '&'
        }
    }
    console.log(str)
    window.open(axios.defaults.baseURL + url + "?" + (str))
}

export function exportData(url, params) { // bbbb这个只是一个post请求的方法名
    let str = '';
    for (let key in params) {
        if (params[key] != '' && params[key] != 'null' && params[key] != undefined) {
            str += key + '=' + escape(params[key]) + '&'
        }
    }
    window.open(axios.defaults.baseURL + url + "?" + (str))
}
